module.exports = __webpack_public_path__ + "static/img/logo.50e0ab12.svg";